import React, { useState, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { Tag } from 'lucide-react'
import { Tabs, TabsList, TabsTrigger, TabsContent } from '@/components/ui/tabs'
import { SuppliersTable } from '@/components/suppliers/SuppliersTable'
import { InvoicesTable } from '@/components/suppliers/InvoicesTable'
import { ReturnsTable } from '@/components/suppliers/ReturnsTable'
import { pageTitle } from '@/lib/appConfig';

export default function SuppliersPage() {
  useEffect(() => {
    document.title = pageTitle('Suppliers');
  }, []);
  const location = useLocation();
  const [activeTab, setActiveTab] = useState<'suppliers' | 'invoices' | 'returns'>('suppliers')
  const [supplierId, setSupplierId] = useState<string | null>(null)

  useEffect(() => {
    const nextTab = (location.state as { tab?: 'suppliers' | 'invoices' | 'returns' } | null)?.tab;
    if (nextTab) {
      setActiveTab(nextTab);
    }
  }, [location.state]);

  const handleSelectSupplier = (id: string) => {
    setSupplierId(id);
    setActiveTab('invoices');
  };

  const handleSelectSupplierReturns = (id: string) => {
    setSupplierId(id);
    setActiveTab('returns');
  };

  return (
    <div className="space-y-8 animate-fade-in">
      <div>
        <h1 className="text-3xl font-bold tracking-tight">Supplier Management</h1>
        <p className="text-muted-foreground mt-1">
          Manage your suppliers, invoices and payments.
        </p>
      </div>

      <Card>
        <CardHeader>
          <div className="flex items-center gap-2">
            <Tag className="h-5 w-5 text-primary" />
            <CardTitle>Suppliers</CardTitle>
          </div>
          <CardDescription>Manage your supplier relationships</CardDescription>
        </CardHeader>
        <CardContent>
          <Tabs value={activeTab} onValueChange={val => setActiveTab(val as any)} className="w-full">
            <TabsList className="mb-4">
              <TabsTrigger value="suppliers">Suppliers</TabsTrigger>
              <TabsTrigger value="invoices">Invoices</TabsTrigger>
              <TabsTrigger value="returns">Returns</TabsTrigger>
            </TabsList>
            <TabsContent value="suppliers">
              <SuppliersTable onSelect={handleSelectSupplier} onSelectReturns={handleSelectSupplierReturns} />
            </TabsContent>
            <TabsContent value="invoices">
              <InvoicesTable supplierId={supplierId} />
            </TabsContent>
            <TabsContent value="returns">
              <ReturnsTable supplierId={supplierId} />
            </TabsContent>
          </Tabs>
        </CardContent>
      </Card>
    </div>
  )
}
